import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { BettingSelectionValues } from "@/types/ApiResponses/BettingSelection";

export interface GetBettingSelectionsParams {
  bettingMarketId?: number;
  lang?: string;
}

export const getBettingSelections = async (
  props: QueryProps<GetBettingSelectionsParams>
): Promise<BettingSelectionValues[]> => {
  const res = await api.client.get(`/betting-selections-new`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
